import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense, forwardRef } from 'react';
export var withSuspense = Component => {
  var Wrapper = forwardRef((props, ref) => {
    return _jsx(Suspense, Object.assign({
      fallback: _jsx(_Fragment, {})
    }, {
      children: _jsx(Component, Object.assign({}, props, {
        ref: ref
      }))
    }));
  });
  return Wrapper;
};